/** @jsx h */

import cn from 'classnames';
import { h, Component } from 'preact';
import { PropTypes } from 'preact-compat';
import styles from './style.scss';

export const BUTTON_THEMES = {
  CALL: 'CALL',
};

class Button extends Component {
  handleClick = (event) => {
    const { onClick } = this.props;

    onClick(event);
  };

  render() {
    const { theme, type, children } = this.props;

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        className={cn(styles.button, { [styles.themeCall]: theme === BUTTON_THEMES.CALL })}
        type={type}
        onClick={this.handleClick}
      >
        {children}
      </button>
    );
  }
}

Button.propTypes = {
  theme: PropTypes.oneOf(Object.values(BUTTON_THEMES)),
  type: PropTypes.oneOf(['button', 'submit']),
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
  theme: '',
  type: 'button',
  children: null,
};

export default Button;



// WEBPACK FOOTER //
// ./components/ui/button/Button.js